import { IChangePasswordParams, ILoginCredentials, LoginResultData } from "@multiweb/clients/auth";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { getCancellationTokenAsRequestContext } from "../../../RequestContext";
import { AuthClient } from "./AuthClient";
import { SESSION_RESET_RESPONSE_CODE } from "./types";

/**
 * Není použita anotace "internal", protože implementace se používá v Samples.
 */
export class ASAuthClient extends AuthClient {
    public override async login(credentials: ILoginCredentials, cancellationToken: CancellationToken = CancellationToken.none): Promise<LoginResultData> {
        let result = await this._login(credentials, cancellationToken);
        if (result === SESSION_RESET_RESPONSE_CODE)
            result = await this._login(credentials, cancellationToken);

        const parts = result.split("|");
        if (parts.length < 2)
            throw Error(`Invalid login response: ${result}`);

        return { result: parts[0], authId: parts[1] };
    }

    private _login(credentials: ILoginCredentials, cancellationToken: CancellationToken): Promise<string> {
        const data = { username: credentials.userName, password: credentials.password, addParams: "" };
        return this._communicationManager.callPOSTRequest("Login", ASServices.owManager, { language: credentials.language }, data, undefined, getCancellationTokenAsRequestContext(cancellationToken)) as Promise<string>;
    }

    public override async changeExpiredPassword(params: IChangePasswordParams, cancellationToken: CancellationToken = CancellationToken.none): Promise<void> {
        const data = { username: params.userName, oldPassword: params.oldPassword, newPassword: params.newPassword, addParams: "" };
        await this._communicationManager.callPOSTRequest("ChangeExpiredPassword", ASServices.owManager, { language: params.language }, data, undefined, getCancellationTokenAsRequestContext(cancellationToken));
    }
}
